// Fichier de données de projets centralisé
const projects = [
  // ReadSphere
  {
    id: "readsphere",
    title: "ReadSphere - Plateforme de Gestion de Bibliothèque Personnelle",
    description:
      "Application web complète en PHP pour gérer une bibliothèque personnelle, partager des critiques et interagir avec d'autres lecteurs.",
    fullDescription: `
    <p>ReadSphere est une plateforme communautaire complète qui permet aux amateurs de lecture de gérer leur collection de livres, de partager des critiques détaillées et d'interagir avec une communauté de lecteurs partageant les mêmes centres d'intérêt. Développée avec une architecture robuste, l'application offre une expérience utilisateur fluide et sécurisée.</p>

    <h3 class="text-xl font-bold mt-6 mb-2">Fonctionnalités principales</h3>
    <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li><strong>Gestion des utilisateurs :</strong>
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
          <li>Inscription et authentification sécurisées avec hachage Argon2id</li>
          <li>Profils personnalisables avec avatars et bibliothèques personnelles</li>
          <li>Tableau de bord adaptatif selon le rôle (Utilisateur/Administrateur)</li>
        </ul>
      </li>
      <li><strong>Gestion des livres :</strong>
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
          <li>Ajout, édition et suppression de livres avec gestion des couvertures</li>
          <li>Système avancé de recherche et de filtrage multicritères</li>
          <li>Catégorisation par genres et étiquettes personnalisables</li>
        </ul>
      </li>
      <li><strong>Interactions sociales :</strong>
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
          <li>Notation des livres et rédaction de critiques détaillées</li>
          <li>Système de commentaires avec mentions et réponses</li>
          <li>Fonctionnalités de like et de favoris</li>
          <li>Notifications en temps réel pour les interactions</li>
        </ul>
      </li>
      <li><strong>Modération :</strong>
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
          <li>Tableau de bord administrateur complet</li>
          <li>Système de signalement et de modération des contenus</li>
          <li>Journal d'audit détaillé des actions administratives</li>
        </ul>
      </li>
    </ul>

    <h3 class="text-xl font-bold mt-6 mb-2">Architecture technique</h3>
    <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li><strong>Backend :</strong> PHP 8.0+ avec architecture MVC personnalisée</li>
      <li><strong>Base de données :</strong> MySQL 8+ avec relations complexes et indexation avancée</li>
      <li><strong>Frontend :</strong> 
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
          <li>HTML5 sémantique et accessible</li>
          <li>Tailwind CSS pour un design responsive</li>
          <li>JavaScript vanilla avec requêtes AJAX pour une expérience fluide</li>
        </ul>
      </li>
      <li><strong>Sécurité :</strong>
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
          <li>Protection CSRF sur tous les formulaires</li>
          <li>Validation et assainissement des entrées utilisateur</li>
          <li>Gestion sécurisée des sessions et des cookies</li>
          <li>Protection contre les attaques XSS et injection SQL</li>
        </ul>
      </li>
    </ul>

    <h3 class="text-xl font-bold mt-6 mb-2">Structure de la base de données</h3>
    <p>Le schéma de base de données est conçu pour une performance optimale :</p>
    <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li>Tables principales : users, books, comments, book_likes, comment_likes, moderation_logs</li>
      <li>Relations claires avec contraintes d'intégrité référentielle</li>
      <li>Index stratégiques pour les recherches fréquentes</li>
      <li>Optimisation pour les opérations de lecture/écriture intensives</li>
    </ul>

    <h3 class="text-xl font-bold mt-6 mb-2">Points forts techniques</h3>
    <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li>Gestion avancée des erreurs et journalisation complète</li>
      <li>Système de routage personnalisé avec réécriture d'URL</li>
      <li>Gestion des téléchargements de fichiers sécurisée</li>
      <li>Système de cache pour améliorer les performances</li>
      <li>Code modulaire et bien documenté pour une maintenance aisée</li>
    </ul>

    <h3 class="text-xl font-bold mt-6 mb-2">Démarrage rapide</h3>
    <ol class="list-decimal pl-5 mb-4 space-y-1 text-gray-300">
      <li>Cloner le dépôt et configurer l'environnement via le fichier <code>.env</code></li>
      <li>Importer le schéma SQL fourni dans le dossier <code>database/</code></li>
      <li>Configurer les permissions des dossiers <code>uploads/</code> et <code>cache/</code></li>
      <li>Configurer les paramètres SMTP pour les emails</li>
    </ol>
  `,
    thumbnail: "assets/images/projects/thumbnails/readsphere-thumb.jpg",
    images: [
      "assets/images/projects/full/read_sphere/im1.png",
      "assets/images/projects/full/read_sphere/im2.png",
      "assets/images/projects/full/read_sphere/im3.png",
      "assets/images/projects/full/read_sphere/im4.png",
      "assets/images/projects/full/read_sphere/im5.png",
      "assets/images/projects/full/read_sphere/im6.png",
      "assets/images/projects/full/read_sphere/im7.png",
      "assets/images/projects/full/read_sphere/im8.png",
      "assets/images/projects/full/read_sphere/im9.png",
      "assets/images/projects/full/read_sphere/im10.png",
      "assets/images/projects/full/read_sphere/im11.png",
      "assets/images/projects/full/read_sphere/im12.png",
      "assets/images/projects/full/read_sphere/im13.png",
      "assets/images/projects/full/read_sphere/im14.png",
      "assets/images/projects/full/read_sphere/im15.png",
      "assets/images/projects/full/read_sphere/im16.png",
      "assets/images/projects/full/read_sphere/im17.png",
      "assets/images/projects/full/read_sphere/im18.png",
      "assets/images/projects/full/read_sphere/im19.png",
    ],
    technologies: [
      "PHP 8+",
      "MySQL 8+",
      "HTML5",
      "Tailwind CSS",
      "JavaScript",
      "PHPMailer",
      "MVC",
      "PDO",
      "AJAX",
    ],
    demoUrl: "https://dev-amine.great-site.net",
    videoUrl: "",
    repoUrl: "https://github.com/Amine830/ReadSphere",
    category: ["fullstack", "backend", "frontend", "web", "social", "books"],
    featured: true,
  },
  // Billard-Book
  {
    id: "billard-book",
    title: "Billard-Book – Plateforme de réservation de billard",
    description:
      "Application web pédagogique complète pour la gestion de réservations de tables de billard, avec authentification JWT, interface Vue 3 moderne, et API Java Spring Boot.",
    fullDescription: `
    <p>Billard-Book est une plateforme web de démonstration permettant de réserver des tables de billard, de gérer des parties, et d'organiser des tournois. Ce projet met en œuvre une architecture moderne avec une API REST Java (Spring Boot) et un client SPA Vue 3, le tout conteneurisé via Docker multi-stage.</p>
    
    <h3 class="text-xl font-bold mt-6 mb-2">Fonctionnalités principales</h3>
    <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li>Authentification stateless par JWT (création de compte, login, édition profil, suppression)</li>
      <li>Réservations de tables, inscription/désinscription à des parties, gestion des participants</li>
      <li>Édition/suppression de réservations (propriétaire uniquement)</li>
      <li>Tableau de bord utilisateur, liste des utilisateurs, statistiques de participation</li>
      <li>Bannière santé backend (health-check Actuator, backoff adaptatif)</li>
      <li>Interface responsive, thème sombre/clair, carrousel d'accueil auto-défilant</li>
      <li>Base URL API dynamique (environnement local/prod)</li>
      <li>Déploiement facile : Docker multi-stage, script build/push, Netlify pour le client</li>
      <li>Galerie de screenshots intégrée</li>
    </ul>
    
    <h3 class="text-xl font-bold mt-6 mb-2">Approche technique</h3>
    <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li>Backend : Java 21, Spring Boot 3, endpoints REST, health-check Actuator</li>
      <li>Frontend : Vue 3, Pinia, TypeScript, Vite, Axios, gestion d’état avancée</li>
      <li>Conteneurisation : Docker multi-stage, scripts d’automatisation build/test/push</li>
      <li>Déploiement : API sur Render/Docker Hub, client sur Netlify</li>
      <li>Pas de base de données persistante (purge régulière, démo uniquement)</li>
    </ul>
    
    <h3 class="text-xl font-bold mt-6 mb-2">Guide d'utilisation</h3>
    <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li>Créer un compte ou se connecter</li>
      <li>Réserver une table ou rejoindre une partie existante</li>
      <li>Gérer son profil, éditer/supprimer ses réservations</li>
      <li>Tester la résilience via la bannière santé (API up/down)</li>
      <li>Consulter la galerie de screenshots pour un aperçu visuel</li>
    </ul>
  `,
    thumbnail:
      "assets/images/projects/thumbnails/spring-billard-reservation-thumb.jpg",
    images: [
      "assets/images/projects/full/billard/billard0.png",
      "assets/images/projects/full/billard/billard1.png",
      "assets/images/projects/full/billard/billard2.png",
      "assets/images/projects/full/billard/billard3.png",
      "assets/images/projects/full/billard/billard4.png",
      "assets/images/projects/full/billard/billard5.png",
      "assets/images/projects/full/billard/billard6.png",
      "assets/images/projects/full/billard/billard7.png",
      "assets/images/projects/full/billard/billard8.png",
      "assets/images/projects/full/billard/billard9.png",
      "assets/images/projects/full/billard/billard10.png",
      "assets/images/projects/full/billard/billard11.png",
      "assets/images/projects/full/billard/billard12.png",
      "assets/images/projects/full/billard/billard13.png",
      "assets/images/projects/full/billard/billard14.png",
      "assets/images/projects/full/billard/billard15.png",
      "assets/images/projects/full/billard/billard16.png",
      "assets/images/projects/full/billard/billard17.png"
    ],
    technologies: [
      "Java 21",
      "Spring Boot 3",
      "Vue 3",
      "TypeScript",
      "Pinia",
      "Vite",
      "Axios",
      "Docker",
      "Netlify"
    ],
    demoUrl: "https://billard-book.netlify.app",
    videoUrl: "",
    repoUrl: "https://github.com/Amine830/spring-billard-reservation",
    category: ["fullstack", "backend", "frontend", "web", "demo", "education"],
    featured: true
  },
  // Eco-Transit
  {
    id: "eco-transit",
    title: "Eco-Transit – Calculateur d'Empreinte Carbone des Transports",
    description:
      "Application web complète pour estimer les émissions de CO2 de différents modes de transport, avec gestion intelligente des quotas API, système de fallback multi-niveaux et authentification utilisateur.",
    fullDescription: `
      <p>Eco-Transit est une plateforme web permettant d'estimer les émissions de CO2 associées à différents modes de transport pour un trajet donné. L'objectif est de sensibiliser les utilisateurs à l'impact environnemental de leurs déplacements et de les aider à choisir des options de transport plus écologiques. Le projet met en œuvre une architecture backend Node.js/Express avec MongoDB, une API REST documentée, et un client web moderne.</p>
      <h3 class="text-xl font-bold mt-6 mb-2">Fonctionnalités principales</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Géocodage intelligent : Conversion d'adresses en coordonnées géographiques via Nominatim (OpenStreetMap)</li>
        <li>Calcul de distance multi-méthodes :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Distance à vol d'oiseau par formule de Haversine</li>
            <li>Distance réelle via l'API Distance Matrix AI pour différents modes de transport</li>
            <li>Fallback automatique sur OpenRouteService et OSRM en cas d'épuisement du quota</li>
          </ul>
        </li>
        <li>Calcul d'émissions CO2 :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>14 modes de transport supportés (voiture, train, bus, avion, vélo, moto, tram, métro, etc.)</li>
            <li>Véhicules électriques et alternatives écologiques (voiture électrique, bus électrique, vélo électrique)</li>
            <li>Carburants alternatifs (bus GNV, etc.)</li>
            <li>Calculs spécialisés pour les vols court, moyen et long courrier</li>
          </ul>
        </li>
        <li>Gestion des utilisateurs :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Création de compte et authentification JWT basique</li>
            <li>Sauvegarde des trajets favoris avec historique</li>
          </ul>
        </li>
        <li>Gestion intelligente des quotas API :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Persistance MongoDB avec suivi en temps réel</li>
            <li>Réinitialisation automatique mensuelle</li>
            <li>Alertes automatiques à 90% d'utilisation</li>
            <li>Endpoint de monitoring public (/api/quota/status)</li>
          </ul>
        </li>
        <li>Système de fallback robuste :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>API principale : Distance Matrix AI (payante, 1000 req/mois)</li>
            <li>Fallback 1 : OpenRouteService (gratuite)</li>
            <li>Fallback 2 : OSRM (gratuite)</li>
            <li>Tolérance aux pannes avec continuité de service</li>
          </ul>
        </li>
      </ul>
      <h3 class="text-xl font-bold mt-6 mb-2">Architecture technique</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Backend : Node.js 23+, Express.js avec architecture MVC
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Contrôleurs : Gestion des routes et logique métier</li>
            <li>Services : Intégrations API externes et logique complexe</li>
            <li>Middlewares : Authentification JWT, gestion d'erreurs centralisée</li>
            <li>Modèles : Mongoose ODM pour MongoDB</li>
          </ul>
        </li>
        <li>Base de données : MongoDB avec Mongoose pour l'ODM
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Gestion des utilisateurs et authentification</li>
            <li>Historique des trajets sauvegardés</li>
            <li>Suivi des quotas API avec persistance</li>
          </ul>
        </li>
        <li>Frontend : HTML5, CSS3, JavaScript vanilla
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Interface responsive et moderne</li>
            <li>Système de notifications personnalisé</li>
            <li>Navigation dynamique</li>
            <li>Configuration centralisée des endpoints API</li>
          </ul>
        </li>
        <li>Sécurité :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>bcrypt pour hachage sécurisé des mots de passe</li>
            <li>JWT pour l'authentification stateless</li>
            <li>Validator pour validation des entrées</li>
            <li>CORS configuré avec origines autorisées</li>
          </ul>
        </li>
        <li>APIs externes :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Impact CO2 (ADEME) pour calculs d'émissions</li>
            <li>Distance Matrix AI pour calculs précis</li>
            <li>OpenRouteService pour fallback</li>
            <li>OSRM pour fallback ultime</li>
            <li>Nominatim pour géocodage</li>
          </ul>
        </li>
        <li>Conteneurisation : Docker multi-stage avec docker-compose
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Image optimisée pour production</li>
            <li>Support MongoDB Atlas</li>
            <li>Variables d'environnement flexibles</li>
          </ul>
        </li>
        <li>Tests : Jest avec couverture de code complète
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Tests unitaires des contrôleurs</li>
            <li>Tests des services et middlewares</li>
            <li>Tests d'intégration avec Supertest</li>
            <li>CI/CD avec GitHub Actions</li>
          </ul>
        </li>
      </ul>
      <h3 class="text-xl font-bold mt-6 mb-2">Patrons de conception</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Singleton : Connexion à la base de données et logger applicatif</li>
        <li>Facade : Services encapsulant les appels API complexes</li>
        <li>Stratégie : Différentes stratégies de calcul de distance selon le contexte</li>
        <li>MVC : Séparation claire entre routes, contrôleurs et services</li>
        <li>Middleware Chain : Pipeline de traitement des requêtes Express</li>
      </ul>
      <h3 class="text-xl font-bold mt-6 mb-2">Points forts du projet</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Système de fallback multi-niveaux garantissant la disponibilité</li>
        <li>Gestion intelligente des quotas API avec monitoring en temps réel</li>
        <li>Architecture robuste et modulaire facile à maintenir</li>
        <li>Documentation API complète avec exemples</li>
        <li>Déploiement simplifié via Docker</li>
        <li>Tests automatisés avec CI/CD</li>
        <li>Sécurité renforcée (JWT, bcrypt, rate limiting)</li>
        <li>Support de 14 modes de transport différents</li>
      </ul>
      <h3 class="text-xl font-bold mt-6 mb-2">Guide d'utilisation</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li><strong>Page d'accueil</strong> : Présentation de l'application et de ses fonctionnalités</li>
        <li><strong>Calculateur</strong> :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Saisir le lieu de départ et d'arrivée (adresse ou coordonnées)</li>
            <li>Visualiser les émissions CO2 pour tous les modes de transport</li>
            <li>Comparer les différentes options de transport</li>
            <li>Sauvegarder les trajets favoris (connexion requise)</li>
          </ul>
        </li>
        <li><strong>Historique</strong> : Consulter et gérer ses trajets sauvegardés</li>
        <li><strong>Compte utilisateur</strong> :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Créer un compte ou se connecter</li>
            <li>Accéder à l'historique de ses calculs</li>
          </ul>
        </li>
        <li><strong>API REST</strong> : Documentation complète disponible via api.md</li>
      </ul>
      <h3 class="text-xl font-bold mt-6 mb-2">Déploiement</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Backend : Docker ou Node.js natif avec MongoDB Atlas</li>
        <li>Frontend : Netlify avec configuration CORS backend</li>
        <li>CI/CD : GitHub Actions pour tests automatisés</li>
        <li>Monitoring : Endpoints de santé et statut des quotas</li>
      </ul>
    `,
    thumbnail: "assets/images/projects/thumbnails/eco-transit-thumb.jpg",
    images: [
      "assets/images/projects/full/eco_transit/1.png",
      "assets/images/projects/full/eco_transit/2.png",
      "assets/images/projects/full/eco_transit/3.png",
      "assets/images/projects/full/eco_transit/4.png",
      "assets/images/projects/full/eco_transit/5.png",
      "assets/images/projects/full/eco_transit/6.png",
      "assets/images/projects/full/eco_transit/7.png",
      "assets/images/projects/full/eco_transit/8.png",
      "assets/images/projects/full/eco_transit/9.png",
      "assets/images/projects/full/eco_transit/10.png",
      "assets/images/projects/full/eco_transit/11.png",
      "assets/images/projects/full/eco_transit/12.png",
      "assets/images/projects/full/eco_transit/13.png",
      "assets/images/projects/full/eco_transit/14.png",
      "assets/images/projects/full/eco_transit/15.png",
      "assets/images/projects/full/eco_transit/16.png",
      "assets/images/projects/full/eco_transit/17.png",
      "assets/images/projects/full/eco_transit/18.png"
    ],
    technologies: [
      "Node.js",
      "Express.js",
      "MongoDB",
      "Mongoose",
      "JWT",
      "bcrypt",
      "HTML5",
      "CSS3",
      "JavaScript",
      "Docker",
      "Jest",
      "Supertest",
      "GitHub Actions",
      "Netlify"
    ],
    demoUrl: "https://eco-transit.netlify.app",
    videoUrl: "",
    repoUrl: "https://github.com/Amine830/eco-transit",
    category: ["fullstack", "web", "environment", "tools", "api", "backend", "frontend"],
    featured: true
  },
  // Demo Hypermedia
  {
    id: "demo-hypermedia",
    title: "Démo Hypermedia : REST vs HATEOAS",
    description:
      "Application pédagogique et interactive pour comparer une API REST classique et une API REST HATEOAS à travers un scénario de commande de pizza. Permet de visualiser concrètement le couplage fort vs faible entre client et serveur.",
    fullDescription: `
      <p><strong>Démo Hypermedia</strong> est une application conçue pour illustrer de manière concrète et visuelle la différence entre une API REST traditionnelle (endpoints fixes, URLs codées en dur) et une API REST HATEOAS (découverte dynamique des liens hypermedia). Le tout est présenté via un cas d'usage simple : la commande de pizzas.</p>
      
      <h3 class="text-xl font-bold mt-6 mb-2">Fonctionnalités principales</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Deux serveurs Node.js distincts : un REST classique et un REST HATEOAS</li>
        <li>Deux clients web séparés (HTML/CSS/JS) pour chaque API, accessibles via le navigateur</li>
        <li>Comparaison visuelle et interactive des comportements côté client lors des changements d’API</li>
        <li>Point d’entrée unique pour l’API HATEOAS, navigation dynamique par liens auto-découverts</li>
        <li>Simulation de pannes ou évolutions d’API pour démontrer la robustesse du modèle HATEOAS</li>
        <li>Tableau comparatif des avantages/inconvénients REST vs HATEOAS (évolutivité, maintenance, couplage…)</li>
        <li>Guide de démonstration détaillé, scripts de test et illustrations pédagogiques</li>
      </ul>

      <h3 class="text-xl font-bold mt-6 mb-2">Approche technique</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Stack 100% JavaScript (Node.js pour les serveurs, JavaScript ES6+ côté client)</li>
        <li>Aucune dépendance front externe : HTML5, CSS3, JS natif</li>
        <li>APIs REST créées from scratch sans frameworks lourds pour la clarté pédagogique</li>
        <li>Script shell pour démarrage automatique de l’ensemble de la démo</li>
      </ul>

      <h3 class="text-xl font-bold mt-6 mb-2">Objectif pédagogique</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Comprendre les limites du REST classique (fragilité aux changements, couplage fort)</li>
        <li>Saisir les atouts d’une API HATEOAS (découvrabilité, robustesse, évolutivité)</li>
        <li>Illustrer le niveau 3 du Richardson Maturity Model de façon concrète</li>
        <li>Mettre en lumière l’importance des hyperliens dans la conception d’API RESTful modernes</li>
      </ul>

      <h3 class="text-xl font-bold mt-6 mb-2">Utilisation</h3>
      <ol class="list-decimal pl-5 mb-4 space-y-1 text-gray-300">
        <li>Lancer les deux serveurs API via le script <code>start-servers.sh</code></li>
        <li>Ouvrir <code>index.html</code> pour accéder à l’interface de comparaison</li>
        <li>Tester les deux clients (REST classique et HATEOAS) en situation réelle</li>
        <li>Observer la gestion des changements d’API, la navigation par liens, et les différences de résilience</li>
      </ol>
    `,
    thumbnail: "assets/images/projects/thumbnails/demo-hypermedia-thumb.jpg", // À personnaliser si tu ajoutes une capture
    images: [
      "assets/images/projects/full/demo_hypermedia/im1.png",
      "assets/images/projects/full/demo_hypermedia/im2.png",
      "assets/images/projects/full/demo_hypermedia/im3.png",
      "assets/images/projects/full/demo_hypermedia/im4.png",
      "assets/images/projects/full/demo_hypermedia/im5.png",
      "assets/images/projects/full/demo_hypermedia/im6.png",
      "assets/images/projects/full/demo_hypermedia/im7.png",
      "assets/images/projects/full/demo_hypermedia/im8.png",
      "assets/images/projects/full/demo_hypermedia/im9.png",
    ],
    technologies: ["Node.js", "JavaScript ES6+", "HTML5", "CSS3"],
    demoUrl: "https://demo-hypermedia.netlify.app/",
    videoUrl: "",
    repoUrl: "https://github.com/Amine830/Demo-hypermedia",
    category: ["educational", "web", "api", "tools", "backend", "frontend"],
    featured: true,
  },
  // Grade Calculator
  {
    id: "grade-calculator",
    title: "Calculateur de Moyenne Générale",
    description:
      "Application web intuitive pour aider les étudiants à calculer leurs moyennes avec une personnalisation complète des matières, des blocs et des semestres.",
    fullDescription: `
      <p>Le Calculateur de Moyenne Générale est une application web conçue pour aider les étudiants à calculer leurs moyennes de manière précise et personnalisée. Cette application permet de gérer plusieurs matières avec des coefficients différents et plusieurs épreuves par matière, chacune avec son propre pourcentage. Elle supporte également une organisation académique avancée avec des blocs de matières et des semestres.</p>
      
      <h3 class="text-xl font-bold mt-6 mb-2">Fonctionnalités principales</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Interface intuitive en 4 étapes : configuration du système d'évaluation, configuration des matières, saisie des notes, affichage des résultats</li>
        <li>Mode sombre/clair avec sauvegarde des préférences</li>
        <li>Organisation académique avancée :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Structure par blocs de matières et/ou par semestres</li>
            <li>Règles de compensation personnalisables entre matières et entre blocs</li>
            <li>Seuil de validation configurable (par défaut : 10/20)</li>
          </ul>
        </li>
        <li>Personnalisation complète :
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Nombre illimité de matières (jusqu'à 50)</li>
            <li>Coefficients personnalisables par matière</li>
            <li>Plusieurs épreuves par matière avec pondération en pourcentage</li>
            <li>Regroupement de matières par blocs et/ou semestres</li>
          </ul>
        </li>
        <li>Visualisation de la structure avec un aperçu interactif de l'organisation académique</li>
        <li>Calcul précis des moyennes pondérées à tous les niveaux (matière, bloc, semestre)</li>
        <li>Affichage détaillé des résultats avec statut de validation</li>
        <li>Exportation des données en formats CSV, JSON et PDF</li>
        <li>Validation en temps réel des saisies pour éviter les erreurs</li>
        <li>Interface responsive fonctionnant sur ordinateurs, tablettes et smartphones</li>
        <li>Persistance des données grâce au stockage local dans le navigateur</li>
      </ul>
      
      <h3 class="text-xl font-bold mt-6 mb-2">Approche technique</h3>
      <p>Ce projet a été réalisé sans aucun framework JavaScript, uniquement avec du JavaScript vanilla, pour garantir des performances optimales et un temps de chargement minimal. L'application utilise des techniques modernes comme le stockage local pour sauvegarder les préférences et les données utilisateur.</p>
      
      <h3 class="text-xl font-bold mt-6 mb-2">Guide d'utilisation</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li><strong>Étape 0 :</strong> Configuration du système d'évaluation
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Définissez la structure académique (semestres et/ou blocs)</li>
            <li>Configurez les règles de validation et de compensation</li>
            <li>Ajoutez des blocs et/ou semestres selon vos besoins</li>
          </ul>
        </li>
        <li><strong>Étape 1 :</strong> Configuration du nombre de matières</li>
        <li><strong>Étape 2 :</strong> Saisie des matières et des notes
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Configuration des matières (nom, coefficient, bloc/semestre)</li>
            <li>Saisie des notes et de leur pondération</li>
          </ul>
        </li>
        <li><strong>Étape 3 :</strong> Résultats
          <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
            <li>Moyenne générale et statut de validation</li>
            <li>Résultats détaillés par bloc et semestre</li>
            <li>Exportation en CSV, JSON ou PDF</li>
          </ul>
        </li>
      </ul>
    `,
    thumbnail: "assets/images/projects/thumbnails/grade-calculator-thumb.jpg",
    images: [
      "assets/images/projects/full/grade/grade1.png",
      "assets/images/projects/full/grade/grade2.png",
      "assets/images/projects/full/grade/grade3.png",
      "assets/images/projects/full/grade/grade4.png",
      "assets/images/projects/full/grade/grade5.png",
      "assets/images/projects/full/grade/grade6.png",
      "assets/images/projects/full/grade/grade7.png",
      "assets/images/projects/full/grade/grade8.png",
      "assets/images/projects/full/grade/grade9.png",
      "assets/images/projects/full/grade/grade10.png",
    ],
    technologies: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "Tailwind CSS",
      "jsPDF",
      "LocalStorage API",
    ],
    demoUrl: "https://grade-calculat0r.netlify.app",
    videoUrl: "",
    repoUrl: "https://github.com/amine830/grade-calculator",
    category: ["frontend", "education", "tools"],
    featured: true,
  },
  // EPL Analytics Dashboard
  {
    id: "epl-dashboard",
    title: "EPL Analytics Dashboard - Analyse Avancee de Matchs",
    description:
      "Dashboard interactif en Python/Dash pour analyser les matchs de Premier League avec statistiques avancees, clustering, reduction de dimension et visualisations dynamiques.",
    fullDescription: `
      <p>EPL Analytics Dashboard est une application data science interactive qui explore plusieurs saisons de matchs de Premier League. Le projet combine analyse statistique, machine learning non supervise et visualisations interactives pour identifier des tendances de jeu, comparer les equipes et interpreter les styles de matchs.</p>

      <h3 class="text-xl font-bold mt-6 mb-2">Fonctionnalites principales</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Dashboard interactif multi-vues avec Dash et Plotly</li>
        <li>Analyse de l'avantage domicile, repartition victoires/nuls/defaites et evolution des buts par saison</li>
        <li>Statistiques par equipe (taux de victoire, buts, tirs moyens domicile/exterieur)</li>
        <li>Tests statistiques : normalite, correlations Pearson/Spearman, bootstrap des intervalles de confiance</li>
        <li>Segmentation des matchs via K-Means, DBSCAN et melanges gaussiens bayesiens</li>
        <li>Reduction de dimension avec PCA (scikit-learn + version manuelle) et t-SNE</li>
        <li>Analyse reseau des equipes avec NetworkX (degre, centralite, betweenness)</li>
      </ul>

      <h3 class="text-xl font-bold mt-6 mb-2">Approche technique</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
        <li>Pipeline de preparation des donnees : nettoyage, conversion des dates, gestion des valeurs manquantes</li>
        <li>Calculs numeriques avec NumPy/SciPy et modelisation avec scikit-learn</li>
        <li>Visualisations riches (tableaux, heatmaps, projections 2D, distributions) avec Plotly</li>
        <li>Execution optimisee avec mode startup leger pour environnements limites</li>
        <li>Deploiement compatible cloud avec Gunicorn et exposition du serveur Flask sous-jacent</li>
      </ul>

      <h3 class="text-xl font-bold mt-6 mb-2">Objectif du projet</h3>
      <p>Ce projet met en pratique une chaine complete d'analyse de donnees sportives : exploration, validation statistique, clustering, interpretation visuelle et restitution dans une interface web analytique exploitable.</p>
    `,
    thumbnail: "assets/images/projects/full/epl_dashboard/application.png",
    images: [
      "assets/images/projects/full/epl_dashboard/1.png",
      "assets/images/projects/full/epl_dashboard/2.png",
      "assets/images/projects/full/epl_dashboard/3.png",
      "assets/images/projects/full/epl_dashboard/4.png",
      "assets/images/projects/full/epl_dashboard/5.png",
      "assets/images/projects/full/epl_dashboard/6.png",
      "assets/images/projects/full/epl_dashboard/7.png",
      "assets/images/projects/full/epl_dashboard/8.png",
      "assets/images/projects/full/epl_dashboard/9.png",
    ],
    technologies: [
      "Python",
      "Dash",
      "Dash Bootstrap Components",
      "Plotly",
      "Pandas",
      "NumPy",
      "SciPy",
      "scikit-learn",
      "NetworkX",
      "Matplotlib",
      "Seaborn",
      "Gunicorn",
    ],
    demoUrl: "https://epl-analytics-dash-app.onrender.com",
    videoUrl: "",
    repoUrl: "https://github.com/Amine830/epl-analytics-dash-app",
    category: ["data-science", "dashboard", "sports", "machine-learning"],
    featured: true,
  },
  // Image Analysis
  {
    id: "image-analysis",
    title: "Projet d'Analyse d'Images",
    description:
      "Application de traitement d'images développée avec OpenCV et Qt, offrant une interface en ligne de commande (CLI) et une interface graphique (GUI) pour appliquer divers filtres et transformations à des images.",
    fullDescription: `
      <p>Ce projet est une application complète de traitement d'images développée avec OpenCV et Qt. L'objectif principal est de recoder toutes les fonctions de filtrage et de transformations géométriques afin de comprendre en profondeur leurs mécanismes et leur implémentation algorithmique. L'application propose à la fois une interface en ligne de commande (CLI) et une interface graphique (GUI).</p>
  
      <h3 class="text-xl font-bold mt-6 mb-2">Fonctionnalités principales</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li>Filtres d'images :
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
        <li>Filtre médian pour réduire le bruit tout en préservant les contours</li>
        <li>Filtre gaussien pour appliquer un flou préservant les structures générales</li>
        <li>Filtre de Sobel pour la détection de contours</li>
        <li>Filtre moyenneur pour appliquer un flou simple</li>
        </ul>
      </li>
      <li>Opérations sur les histogrammes :
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
        <li>Affichage de l'histogramme et de l'histogramme cumulé</li>
        <li>Égalisation d'histogramme pour améliorer le contraste</li>
        <li>Étirement d'histogramme pour optimiser la plage des valeurs d'intensité</li>
        </ul>
      </li>
      <li>Transformations géométriques :
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
        <li>Zoom et agrandissement avec interpolation</li>
        <li>Réduction de la taille de l'image</li>
        <li>Rotation selon un angle donné</li>
        <li>Retournement horizontal ou vertical</li>
        <li>Compression pour réduire la taille du fichier</li>
        </ul>
      </li>
      <li>Interface utilisateur double :
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
        <li>Interface CLI pour un usage rapide en ligne de commande</li>
        <li>Interface GUI intuitive avec boutons dédiés pour chaque opération</li>
        <li>Affichage en temps réel des images et des histogrammes</li>
        </ul>
      </li>
      </ul>
  
      <h3 class="text-xl font-bold mt-6 mb-2">Approche technique</h3>
      <p>Ce projet met l'accent sur l'implémentation manuelle des algorithmes de traitement d'images plutôt que sur l'utilisation des fonctions prédéfinies d'OpenCV. Cette approche permet une compréhension approfondie des mécanismes sous-jacents et offre une flexibilité maximale pour personnaliser chaque traitement.</p>
  
      <h3 class="text-xl font-bold mt-6 mb-2">Utilisation</h3>
      <ul class="list-disc pl-5 mb-4 space-y-1 text-gray-300">
      <li>Version CLI :
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
        <li>Chargement d'une image depuis le système de fichiers</li>
        <li>Application de différents filtres et transformations</li>
        <li>Enregistrement de l'image modifiée</li>
        <li>Affichage des histogrammes à chaque étape du traitement</li>
        </ul>
      </li>
      <li>Version GUI :
        <ul class="list-circle pl-5 mt-1 mb-1 space-y-1 text-gray-300">
        <li>Interface intuitive avec des boutons pour chaque opération</li>
        <li>Chargement et sauvegarde d'images par interface graphique</li>
        <li>Boutons dédiés pour chaque type de filtre et transformation</li>
        <li>Affichage en temps réel de l'image et des histogrammes</li>
        </ul>
      </li>
      </ul>
    `,
    thumbnail: "img/Screenshots/Capture d'écran 2024-12-17 211829.png",
    images: [
      "assets/images/projects/full/img_analysis/img_analysis1.png",
      "assets/images/projects/full/img_analysis/img_analysis2.png",
      "assets/images/projects/full/img_analysis/img_analysis3.png",
      "assets/images/projects/full/img_analysis/img_analysis4.png",
      "assets/images/projects/full/img_analysis/img_analysis5.png",
      "assets/images/projects/full/img_analysis/img_analysis6.png",
      "assets/images/projects/full/img_analysis/img_analysis7.png",
      "assets/images/projects/full/img_analysis/img_analysis8.png",
      "assets/images/projects/full/img_analysis/img_analysis9.png",
      "assets/images/projects/full/img_analysis/img_analysis10.png",
      "assets/images/projects/full/img_analysis/img_analysis11.png",
    ],
    technologies: ["C++", "OpenCV", "Qt", "CMake", "Traitement d'Images"],
    demoUrl: "",
    videoUrl: "",
    repoUrl: "https://github.com/Amine830/image-analysis",
    category: ["desktop", "computer-vision", "image-processing", "tools"],
    featured: true,
  },
];

// Vérification de sécurité pour éviter les erreurs
if (typeof window !== "undefined") {
  window.projects = projects;
}
